import { get as lodashGet } from "lodash-es";
import { useFilterHeaderOptionBasedOnUserGroup } from "./useFilterHeaderOptionBasedOnUserGroup";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

export const useShowHeaderDropdownOptions = () => {
  const { data: config } = useInstanceConfigQuery();
  const dropdownOptions = lodashGet(
    config,
    "custom_ui_labels.header_dropdown_options",
    []
  );

  const headerDropdownOptions =
    useFilterHeaderOptionBasedOnUserGroup(dropdownOptions);

  return headerDropdownOptions;
};
